export var DocumentKind;
(function (DocumentKind) {
    DocumentKind["INVOICE"] = "invoice";
    DocumentKind["CREDIT_NOTE"] = "credit_note";
    DocumentKind["DUNNING_LETTER"] = "dunning_letter";
    /**
     * Honorarvereinbarung (TM-9198) — the concluded private fee agreement handed
     * to a self_pay / pkv / beihilfe patient before treatment. Unlike the three
     * kinds above it is NOT a §147 AO Buchungsbeleg: it lives in a separate,
     * non-WORM bucket and may be overwritten ("neu erzeugen"). See ADR-0023.
     */
    DocumentKind["HONORARVEREINBARUNG"] = "honorarvereinbarung";
    /**
     * Begleitzettel for Urbelege under §302 Anlage 4, with the stacking list of
     * the Urbelege per Gesamtrechnung (TM-9540 / #1554).
     *
     * ⚠ **The fourth accompanying sheet in this domain and the only one that is
     * ours.** A sheet's identity is addressee plus legal basis, never its name:
     * this one goes to the Belegannahmestelle (`VKG 09`) on the basis of Anlage 4
     * — not to a Rechenzentrum, not under an insurance contract, and it is not the
     * Datenträgerbegleitzettel from Anhang 1 §4.6.2.
     *
     * Like the Honorarvereinbarung **not a §147 AO Buchungsbeleg**: no amount, no
     * tax identity, fully reconstructable from the billing run. Non-WORM bucket
     * per ADR-0023, and without a patient — one sheet covers a whole
     * Gesamtrechnung across many patients.
     */
    DocumentKind["GKV_BEGLEITZETTEL"] = "gkv_begleitzettel";
    /**
     * The Mitteilung under § 18 of the Verträge nach § 125 Abs. 1 SGB V: the sheet
     * a practice tells its Kassen with that Therame is its Abrechnungsstelle from
     * a given day — and later, until when (TM-9636 / #1632).
     *
     * ⚠ **The duty stands in the §125-Vertrag, not in the §302 Richtlinien.** The
     * paragraph depends on the Heilmittelbereich: Abs. 13 for Physio- and
     * Ergotherapie, Abs. 14 for SSSST and Ernährungstherapie, Abs. 15 for
     * Podologie (#1582). A practice can have several Bereiche, so the sheet names
     * only the paragraph.
     *
     * ⚠ **Therame produces it, the practice sends it.** The sheet carries
     * Therame's name and IK, but the letter's sender is the practice: the
     * Mitteilung is its duty towards its Kassen, not Therame's towards somebody
     * else's. Sending it automatically from here would be a declaration in
     * somebody else's name.
     *
     * ⚠ **Every generation stays on record.** There are two occasions — the
     * beginning and the end of the Beauftragung — and both are sheets of their own
     * with ids of their own. The second does not overwrite the first: the Kassen
     * have already received the first.
     *
     * Like the Honorarvereinbarung and the Begleitzettel **not a §147 AO
     * Buchungsbeleg**: no amount, no tax identity, no patient. Non-WORM bucket per
     * ADR-0023.
     */
    DocumentKind["GKV_PARAGRAF_18_MITTEILUNG"] = "gkv_paragraf_18_mitteilung";
})(DocumentKind || (DocumentKind = {}));
//# sourceMappingURL=document-kind.enum.js.map